import React, {useState} from 'react';
import axios from 'axios';
import Header from "../../components/Headers/Header";
import {getCookie} from "tools/tools"
import {LangCodes, LocaleContext, TokenInput, TokenInputType} from '@skbkontur/react-ui';

import {
    FormGroup,
    Form,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Row,
    Col,
    Card,
    CardHeader,
    Button,
    Label,
    Table,
    CardFooter,
    Pagination,
    PaginationItem,
    PaginationLink,
    Container,
    Media,
    Badge,
    UncontrolledTooltip,
    Progress,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    CardBody
} from "reactstrap";
import {FileUploader, Loader} from "@skbkontur/react-ui";
import FileModal from "../../components/Modals/FileModal";
import InfoModal from "../../components/Modals/InfoModal";
import {useTranslation} from "react-i18next";

const DicomConverter = () => {
    const [file, setFile] = useState(null);
    const [uploadPercentage, setUploadPercentage] = useState(0);
    const [uploading, setUploading] = useState(false);
    const [modalData, setModalData] = useState(null);
    const [convertErrors, setConvertErrors] = useState([]);
    const [modalIsOpen, setModalIsOpen] = useState(false);

    const closeModal = () => setModalIsOpen(false);

    const onFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const onFileUpload = async () => {
        const formData = new FormData();
        formData.append('file', file);

        try {
            setUploading(true);
            const response = await axios.post('/api/dicom-to-nii', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'X-CSRFToken': getCookie('csrftoken')
                },
                withCredentials: true,
                onUploadProgress: (progressEvent) => {
                    const {loaded, total} = progressEvent;
                    let percent = Math.floor((loaded * 100) / total);
                    setUploadPercentage(percent);
                }
            });

            console.log(response.data);
            setModalData(response.data['converted_files']);
            setConvertErrors(response.data['errors'])
            setModalIsOpen(true);
        } catch (error) {
            console.error('Error uploading file:', error);
            setModalData(error);
            setModalIsOpen(true);
            alert('Error uploading file');
        } finally {
            setUploading(false);
            setUploadPercentage(0);
        }
    };

    const cardBody = () => {
        return (<CardBody>
            <Form className="">
                <FormGroup>
                    <LocaleContext.Provider value={{langCode: LangCodes.en_GB}}>
                        <FileUploader onChange={onFileChange}/>
                    </LocaleContext.Provider>

                </FormGroup>
                {uploading && (
                    <Progress value={uploadPercentage} className="mb-3">
                        {uploadPercentage}%
                    </Progress>
                )}
                <Button
                    color="primary"
                    onClick={onFileUpload}
                    disabled={!file || uploading}
                >
                    {uploading ? t('Converting') : t('Convert')}
                </Button>
            </Form>
        </CardBody>)
    }

    const modalBody = () => {
        console.log("modal data", modalData)

        if (convertErrors.length !== 0) {
            return convertErrors.map((item, index) => (
                <ul key={index}>
                    <li>
                        {item}
                    </li>
                </ul>
            ))
        }

        return modalData == null || modalData.length === 0 ? ('files not fount') : (<ul>
            {modalData.map((item, index) => (
                <li key={index}>
                    <a href={item.file_url} target="_blank" rel="noopener noreferrer">
                        {item.filename}
                    </a>

                </li>
            ))}
        </ul>)
    }

    const { t, i18n } = useTranslation();
    return (
        <>
            <InfoModal
                isOpen={modalIsOpen}
                modalTitle={'Converted files'}
                onRequestClose={closeModal}
                body={modalBody}
                contentLabel="Example Modal">
            </InfoModal>
            <Header/>
            {/* Page content */}
            <Container className="mt--7" fluid>
                {/* Table */}
                <Row>
                    <div className="col">
                        <Card className="shadow">
                            <CardHeader className="border-0">
                                <h3 className="mb-0">{t('DicomDesc')}</h3>
                            </CardHeader>
                            {uploading ? (<Loader active={uploading}>
                                {cardBody()}
                            </Loader>) : (cardBody())}


                            <CardFooter className="py-4">
                            </CardFooter>
                        </Card>
                    </div>
                </Row>
            </Container>
        </>
    )
}

export default DicomConverter;